import CheckboxInputComponent from "@/component/input/checkboxInput";
import LabeledInputComponent from "@/component/input/labeledInput";
import AutoCompleteComponent from "./autoCompleteInput";
import DateInputComponent from "./dateInput";
import FilterDateRangePickerComponent from "./filterDateRangePicker";
import DateRangePickerComponent from "./dateRangePicker";
import DateTimeInputComponent from "./dateTimePicker";
import RadioInputComponent from "./radioInput";
import SelectInputComponent from "./selectInput";
import SwitchComponent from "./switch";
import TimeInputComponent from "./timeInput";
import UploadFileComponent from "./uploadfile";

export type SelectOptions = {
  name?: string;
  _id?: any;
  id?: any;
  value: string;
  label: string;
  isGroupTitle?: boolean;
  count?: number;
  disabled?: boolean;
};
export type RadioOptions<ValueType = string> = {
  value: ValueType;
  label: string;
};

export const LabeledInput = LabeledInputComponent;
export const CheckBoxInput = CheckboxInputComponent;
export const SelectInput = SelectInputComponent;
export const RadioInput = RadioInputComponent;
export const SwitchInput = SwitchComponent;
export const DateInput = DateInputComponent;
export const DateTimeInput = DateTimeInputComponent;
export const TimeInput = TimeInputComponent;
export const UploadFile = UploadFileComponent;
export const AutoCompleteInput = AutoCompleteComponent;
export const DateRangeInput = DateRangePickerComponent;
export const FilterDateRangePicker = FilterDateRangePickerComponent;
export { toUtcDateRangeBounds } from "./filterDateRangePicker";
export type { FilterDateRange } from "./filterDateRangePicker";
